/* eslint-disable no-control-regex */
import * as Yup from 'yup';

export default Yup.object({
  incidentCountry: Yup.string().required('Required'),
  incidentCity: Yup.string()
    .required('Required')
    .test('isExtendedASCII', 'City contains invalid characters', (value) =>
      /^([\x00-\xFF]*)$/g.test(value)
    ),
  claimCurrency: Yup.string().required('Required'),
  claimAmount: Yup.string()
    .matches(
      /^\d{1,12}(\.\d{0,2})?$/,
      'Invalid amount format (max 12 digits + optional 2 decimals)'
    )
    .required('Required'),
  dateOfService: Yup.date().required('Required')
});
